<template>
  <div class='login-container'>
    <el-form class='login-form' auto-complete='on' label-position='left'>
      <div class='title-container'>
        <h3 class='title'>宝山红十字会</h3>
      </div>

      <el-form-item prop='account'>
        <i class='el-icon-s-custom ml20'></i>
        <el-input
          ref='username'
          v-model='loginForm.account'
          placeholder='账号'
          name='username'
          type='text'
          tabindex='1'
          auto-complete='on'
        />
      </el-form-item>

      <el-form-item prop='password'>
        <i class='el-icon-s-goods ml20'></i>

        <el-input
          :key='passwordType'
          ref='password'
          v-model='loginForm.password'
          :type='passwordType'
          placeholder='密码'
          name='password'
          tabindex='2'
          auto-complete='on'
          @keyup.enter.native='handleLogin'
        />
      </el-form-item>



      <div style="display: flex">
        <el-form-item prop='password' style="width: 65%">
        <i class='el-icon-s-goods ml20'></i>

        <el-input
          style="width:65%"
          ref='code'
          v-model='loginForm.code'
          :type='passwordType'
          placeholder='验证码'
          name='code'
          tabindex='2'
          auto-complete='on'
          @keyup.enter.native='handleLogin'
        />
     
       
      </el-form-item>
        <img @click="getCode()" style="width: 20%;height: 47px;margin-left: 30px;" :src="this.code_img" alt="">
      </div>
      



      <el-button
        :loading='loading'
        type='primary'
        style='width:100%;margin-bottom:30px;'
        @click.native.prevent='handleLogin'
      >Login</el-button>
    </el-form>
  </div>
</template>

<script>
// import { validUsername } from '@/utils/validate'

export default {
  name: "Login",
  data() {
    return {
      loginForm: {
        account: "",
        password: "",
        code:"",
        c_id:""
      },
      code_img:"",
      loading: false,
      passwordType: "password",
      redirect: undefined
    };
  },
  watch: {},
  mounted() {
    this.getCode()
  },
  methods: {
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      if (!this.loginForm.account) {
        this.$message("请输入用户名");
        return;
      }
      if (!this.loginForm.password) {
        this.$message("请输入密码");
             return;
      } if (!this.loginForm.code) {
        this.$message("请输入验证码");
             return;
      }
 
 
      this.post("admin/user/login", this.loginForm).then(res => {

        sessionStorage.setItem("token",res.data)

        this.$router.push({
          path:"/contributeMoney"
        })
      });
    },
    getCode(){
      this.post("admin/user/getCaptcha",{}).then(res=>{
            let data=res.data;
            this.loginForm.c_id=data.c_id;
            this.code_img="data:image/png;base64,"+ data.code_img

      })
    }
  }
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #283443;
$light_gray: #fff;
$cursor: #fff;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  height: 100vh;
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
$bg: #2d3a4b;
$dark_gray: #889aa4;
$light_gray: #eee;

.login-container {
  min-height: 100%;
  width: 100%;
  background-color: $bg;
  overflow: hidden;

  .login-form {
    position: relative;
    width: 520px;
    max-width: 100%;
    padding: 160px 35px 0;
    margin: 0 auto;
    overflow: hidden;
  }

  .tips {
    font-size: 14px;
    color: #fff;
    margin-bottom: 10px;

    span {
      &:first-of-type {
        margin-right: 16px;
      }
    }
  }

  .svg-container {
    padding: 6px 5px 6px 15px;
    color: $dark_gray;
    vertical-align: middle;
    width: 30px;
    display: inline-block;
  }

  .title-container {
    position: relative;

    .title {
      font-size: 26px;
      color: $light_gray;
      margin: 0px auto 40px auto;
      text-align: center;
      font-weight: bold;
    }
  }

  .show-pwd {
    position: absolute;
    right: 10px;
    top: 7px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
  }
}
</style>
